<template>
  <div class="client-space" v-if="this.$store.state.authenticated">
    <ClientNavbar />
    
    <main class="main-content">
      <router-view></router-view>
    </main>
    
    <ClientFooter />
  </div>

  <router-view v-else></router-view>
  
  <ShowToast />
  <DynamicDialog :contentStyle="{ padding: 0 }" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ClientNavbar from './layouts/ClientNavbar.vue'
import ClientFooter from './layouts/ClientFooter.vue'

export default defineComponent({
  name: 'App',
  components: {
    ClientNavbar,
    ClientFooter
  },
  mounted() {
    this.axios.get('/sanctum/csrf-cookie').then(() => {
      console.log('sanctum/csrf-cookie ok')
    }).catch(() => {
      window.location.reload()
      this.$toast.add({
        severity: 'error',
        summary: 'Probleme de connexion',
        detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
        life: 5000
      });
    });
  },
})
</script>

<style scoped>
.client-space {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding: 20px;
  margin-top: 60px; /* Pour compenser la navbar fixe */
  margin-bottom: 60px; /* Pour compenser le footer fixe */
}
</style>